<div class="kontakti-page">

    <div class="kontakti-page__container">
        <kontakti-tablica *ngIf="kontakti" [kontakti]="kontakti"></kontakti-tablica>
    </div>

</div>
